import { createStateContext } from "react-use";

import { createLocationModel } from "../../../utils/model";

const [useCreateLocation, CreateLocationProvider] = createStateContext<Locality>(createLocationModel());

export { useCreateLocation, CreateLocationProvider };
